import { Controller } from "@hotwired/stimulus"

// Bridges `Employee::ReportingHierarchySelectComponent` (which dispatches
// `bk360-team-member-select-changed`) to URL-driven filtering on the
// Team Playbook report. Updates query params and reloads.
export default class extends Controller {
  connect() {
    this.handler = this.#apply.bind(this)
    document.addEventListener("bk360-team-member-select-changed", this.handler)
  }

  disconnect() {
    document.removeEventListener("bk360-team-member-select-changed", this.handler)
  }

  #apply(event) {
    const { team_manager_ids = [], pod_leader_ids = [], pod_employee_ids = [] } = event.detail || {}
    const params = new URLSearchParams(window.location.search)

    params.delete("team_manager_ids[]")
    params.delete("pod_leader_ids[]")
    params.delete("pod_employee_ids[]")

    team_manager_ids.forEach((id) => params.append("team_manager_ids[]", id))
    pod_leader_ids.forEach((id) => params.append("pod_leader_ids[]", id))
    pod_employee_ids.forEach((id) => params.append("pod_employee_ids[]", id))

    params.delete("page")
    const qs = params.toString()
    Turbo.visit(qs ? `${window.location.pathname}?${qs}` : window.location.pathname)
  }
}
